module.exports = __webpack_public_path__ + "img/2_23.f0e65f40.jpg";